<div class="date-picker-container">
  <div [formGroup]="formGroupScope" [id]="name">
    <input matInput [matDatepicker]="datePicker" [formControlName]="name" [min]="minimumDate" [value]="dateNow" [max]="maximumDate" (click)="datePicker.open()" onselect="changeEvent($event)">
    <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
    <mat-datepicker #datePicker></mat-datepicker>
  </div>
</div>
